// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__2JrIV","navContainer":"styles_navContainer__2CYDA","menu":"styles_menu__3jZ3V","about":"styles_about__1jRt1","info":"styles_info__1WF0S"};